// TODO - move to a higher level shared location

export const UpdateContactForm = {
    // NODE NAME
    updateContactName: "updateContactName",
    // EVENT
    eventName: "eventName",
    // EVENT - PROPERTIES
    propertiesListName: "properties",
    propertyName: "propertyName",
    propertyValue: "propertyValue",
    propertyType: "propertyType", // hidden

    // PROFILE - ATTRIBUTES
    profileListName: "profileAttributesList",
    profileAttrName: "profileAttrName",
    profileAttrValue: "profileAttrValue",
    profileAttrType: "profileAttrType", // hidden
    // ERROR MESSAGE
    updateContactError: "updateContactError",
};

// these are used in the IVR as well, and come from the backend
// we should consider moving these to a shared location
// attribute types or something...
export const FIELD_TYPE_STRING = "string";
export const FIELD_TYPE_NUMBER = "number";
export const FIELD_TYPE_BOOLEAN = "boolean";
export const FIELD_TYPE_OBJECT = "object";
export const FIELD_TYPE_DATE = "datetime";
export const FIELD_TYPE_LIST = "list";
// this doesnt go to the backend, using an empty string to represent a new custom field
// the user is forced to select a type before they can save
export const FIELD_TYPE_NEW_CUSTOM = "";

export const CURRENT_TIME_LOCAL_HANDLEBARS = "{{#local_time}}{{now}}{{/local_time}}";
/** Inner template text inserted by ConfigurableVariablesPickerPlugin (outer {{ }} added by plugin). */
export const CURRENT_TIME_LOCAL_TEMPLATE = "#local_time}}{{now}}{{/local_time";
export const LOCAL_TIME_HANDLEBARS_WRAP = /\{\{#local_time\}\}\{\{now\}\}\{\{\/local_time\}\}/;
